<template>
<div class="w-85per dp-inblock">
    <div class="title">
        <h2>결제 방식</h2>
        <p>
            - * 는 필수 입력 항목입니다. <br>
            - <span class="txt-red">면세(전화영어) / 과세(글로벌 과정은 VAT10%반영 금액 입력 필수)</span><br>
            <span class="pl-05">ex) 매출이 5만원이라면 VAT 10% 이후 금액인 55,000원을 입력해야 매출 5만원으로 인정됨 (vat 전 금액)</span> <br>
            - <span class="bold">주의 : 50,000원 입력하면 매출이 45,454 로 인정됨</span>
        </p>
    </div>
    <table class="admin-table-row table-auto">
        <thead>
            <tr>
                <th>결제방법 <span class="txt-red">*</span></th>
                <td>
                    <label for="payWay">
                        <input type="checkbox" v-model="payCard" name="payWay" id="">
                        <span class="txt-13px ml-05 mr-20">카드결제</span>
                    </label>
                    <label for="payWay">
                        <input type="checkbox" v-model="payTransfer" name="payWay" id="">
                        <span class="txt-13px ml-05 mr-20">실시간 계좌이체</span>
                    </label>
                </td>
            </tr>
            <tr>
                <th>면세구분 <span class="txt-red">*</span></th>
                <td>
                    <label for="taxType">
                        <input type="radio" v-model="taxType" value="T" name="taxType" id="">
                        <span class="txt-13px ml-05 mr-20">과세</span>
                    </label>
                    <label for="taxType">
                        <input type="radio" v-model="taxType" value="F" name="taxType" id="">
                        <span class="txt-13px ml-05 mr-20">면세</span>
                    </label>
                </td>
            </tr>
            <tr>
                <th>결제 여부 <span class="txt-red">*</span></th>
                <td>
                    <label for="taxType">
                        <input type="radio" v-model="partialPay" value="A" name="partialPay" id="">
                        <span class="txt-13px ml-05 mr-20">전체 결제</span>
                    </label>
<!--                     <label for="taxType">
                        <input type="radio" v-model="partialPay" value="P" name="partialPay" id="">
                        <span class="txt-13px ml-05 mr-20">부분 결제</span>
                    </label> -->
                </td>
            </tr>
        </thead>
    </table>
    <div class="line"></div>
    <div class="mt-30 w-100per mg-auto">
        <button @click="prev()" class="admin-btn-default">이전</button>
        <button @click="next()" class="admin-btn-default float-right ml-05">
            <span v-if="isFinishPage">완료하기</span>
            <span v-else>다음</span>
        </button>
        <button @click="save()" class="admin-btn-default float-right ml-05">저장</button>
        <button @click="preview()" class="admin-btn-default float-right">미리보기</button>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({
        payWay: '', // 카드결제 C, 실시간 계좌이체 A, 둘다 D
        taxType: 'T', // 면세 F, 과세 T
        partialPay: 'A', // 전체결제 A 부분결제 P

        payCard: true,
        payTransfer: true,

        isSaved: false, // 저장 여부
        isFinishPage: false // 현재 페이지가 마지막 페이지인지
    }),

    mounted() {
        if (sessionStorage.getItem('fix')) {
            var idx = sessionStorage.getItem('mainIdx')
            this.axios.get(this.axios.root + this.axios.port + `/sugang/pay-way/${idx}`)
                .then(res => {
                    console.log('res', res)
                    // 불러오기 - 결제방식 불러온경우
                    if (res.data.payWay.pay_way) {
                        this.payWay = res.data.payWay.pay_way
                        if (this.payWay === 'D') {
                            this.payCard = true
                            this.payTransfer = true
                        } else if (this.payWay === 'A') {
                            this.payCard = false
                            this.payTransfer = true
                        } else if (this.payWay === 'C') {
                            this.payCard = true
                            this.payTransfer = false
                        } else {
                            this.payCard = false
                            this.payTransfer = false
                        }
                    }

                    // 불러오기 - 면세구분 불러온경우
                    if (res.data.payWay.tax_type) {
                        this.taxType = res.data.payWay.tax_type
                    }

                    // 불러오기 - 부분결제 불러온경우
                    if (res.data.payWay.partial_pay) {
                        this.partialPay = res.data.payWay.partial_pay
                    }
                }).catch(err => {
                    console.log(err)
                    alert(err)
                })
        }

        var pathArray = this.$route.fullPath.split('/')
        var length = pathArray.length
        var pageType = pathArray[length - 1]
        var pOrder = JSON.parse(sessionStorage.getItem('pOrder'))
        var finishPage = pOrder[pOrder.length - 1]

        if (pageType === finishPage) {
            this.isFinishPage = true
        }
    },

    methods: {
        // 미리보기
        preview() {
            if (!this.isSaved) {
                alert('미리보기를 하려면 먼저 저장을 해야합니다.')
                return false
            }
            let routeData = this.$router.resolve({
                name: 'preview-purchase',
                query: {
                    mainIdx: sessionStorage.getItem('mainIdx')
                }
            });
            window.open(routeData.href, '_blank');
        },

        // 이전 페이지 이동
        prev() {
            var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
            var idx = pOrder.indexOf('purchase') - 1
            this.$router.push(`/admin/reg/${pOrder[idx]}`)
            // this.$router.push('/admin/reg/userInfo')
        },

        // 다음 페이지 이동
        next() {
            if (this.isSaved) {
                if (this.isFinishPage) {
                    alert('수강신청 등록이 완료되었습니다.')
                    this.$router.push('/admin/list/main')
                } else {
                    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
                    var idx = pOrder.indexOf('purchase') + 1
                    sessionStorage.setItem('step', pOrder[idx])
                    this.$router.push(`/admin/reg/${pOrder[idx]}`)
                }
            } else {
                alert('저장을 먼저 해주세요.')
                return false
            }
        },

        // 현재 페이지 저장
        save() {
            if (this.payCard && this.payTransfer) {
                this.payWay = 'D'
            } else if (this.payCard && !this.payTransfer) {
                this.payWay = 'C'
            } else if (!this.payCard && this.payTransfer) {
                this.payWay = 'A'
            } else if (!this.payCard && !this.payTransfer) {
                this.payWay = ''
            }

            console.log('this.payWay', this.payWay)

            var params = {
                completeContents: 'test',
                mainIdx: sessionStorage.getItem('mainIdx'),
                payWay: this.payWay,
                // popupContents: 'test',
                // popupTitle: 'test',
                taxType: this.taxType,
                partialPay: this.partialPay
            }

            this.axios.put(this.axios.root + this.axios.port + '/sugang/pay-way', params)
                .then(res => {
                    console.log('res', res)
                    if (res.data.err === 0) {
                        this.isSaved = true
                        alert('저장되었습니다.')
                    }
                })
        }
    }
}
</script>
